import { Type } from '@angular/core';

export class OutlineItem {
  constructor(public component: Type<any>, public data: any) {}
}
